import "../../Assets/styles/PrintButton.css";
export const PrintButton = (props) => {
  return (
    <button onClick={props.onclick} className="print-button">
      <span className="print-icon"></span>
    </button>
  );
};
